(function () {
  'use strict';
  document.documentElement.classList.add('cc-collection-page');
  var key = 'cc-collection-columns';
  var allowed = ['3', '4', '5'];
  var selected = '4';
  try {
    var saved = localStorage.getItem(key);
    if (allowed.indexOf(saved) !== -1) selected = saved;
  } catch (_) {}
  document.documentElement.dataset.ccCollectionColumns = selected;

  function syncButtons() {
    document.querySelectorAll('[data-cc-columns]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.ccColumns === selected));
    });
  }
  function setColumns(columns) {
    if (allowed.indexOf(columns) === -1) return;
    selected = columns;
    document.documentElement.dataset.ccCollectionColumns = columns;
    try { localStorage.setItem(key, columns); } catch (_) {}
    syncButtons();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cc-columns]');
    if (button) setColumns(button.dataset.ccColumns);
  });

  var frame = 0;
  function updateHeaderStack() {
    frame = 0;
    var strip = document.querySelector('.cc-brand-strip-section');
    var header = document.querySelector('.section-header');
    var subnav = document.querySelector('.cc-brand-subnav-section');
    function stickyHeight(element) {
      if (!element) return 0;
      var position = getComputedStyle(element).position;
      return position === 'sticky' || position === 'fixed' ? Math.ceil(element.getBoundingClientRect().height) : 0;
    }
    var stripHeight = stickyHeight(strip);
    var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    var subnavHeight = stickyHeight(subnav);
    document.documentElement.style.setProperty('--cc-sticky-strip-height', stripHeight + 'px');
    document.documentElement.style.setProperty('--cc-main-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--cc-filter-stack-height', stripHeight + headerHeight + subnavHeight + 'px');
  }
  function scheduleStack() {
    if (!frame) frame = requestAnimationFrame(updateHeaderStack);
  }
  window.addEventListener('scroll', scheduleStack, { passive: true });
  window.addEventListener('resize', scheduleStack, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncButtons(); updateHeaderStack(); });
  } else {
    syncButtons();
    updateHeaderStack();
  }
})();